import React, { useEffect, useState, memo, Fragment, Suspense } from 'react'
import { LinearProgress, Paper, Rating, Button } from '@mui/material';
// import MaterialTable from '@material-table/core';
import SaveIcon from '@mui/icons-material/Save';
import BookIcon from '@mui/icons-material/Book';
import { Column } from '@material-table/core';
import { tableStyles } from '../TableStyles';
import Toolbar from './Toolbar';
import { SaveModal } from '../../Modals/SaveModal';
import { RatesTableProps, RowTableObject } from '../../../../pages/get-quote/models';
import QuoteBreakdownModal from '../../Modals/QuoteBreakdownModal';
import { KTSVG } from '../../../../../_metronic/helpers';
import { dollarUSLocale } from '../../../../helpers/dollarUSLocale';
import { saveAs } from 'file-saver';
import axios from 'axios';
import { checkErrorAPICall } from '../../../../helpers/checkErrorAPICall';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import { RootState } from '../../../../../setup';
import { UserModel } from '../../../../modules/auth/models/UserModel';
import { actionTypes } from '../../../../modules/auth/redux/PagesRedux';
import { useNavigate } from 'react-router-dom';
import EmailIcon from '@mui/icons-material/Email';
import EmailDocuments from '../../../TrackingGridPage/DocumentsModal/EmailDocuments';
// import { alpha } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
// import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import TableSortLabel from '@mui/material/TableSortLabel';
// import Toolbar from '@mui/material/Toolbar';
// import Typography from '@mui/material/Typography';
// import Paper from '@mui/material/Paper';
// import Checkbox from '@mui/material/Checkbox';
// import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
// import FormControlLabel from '@mui/material/FormControlLabel';
// import Switch from '@mui/material/Switch';
// import DeleteIcon from '@mui/icons-material/Delete';
// import FilterListIcon from '@mui/icons-material/FilterList';
import { visuallyHidden } from '@mui/utils'
import { useStyles } from '../../FreightInfo/FreightInformation/FreightInformationStyles';

interface Data {
  id: number;
  service: string;
  total: number;
  transitDays: string;
  name: string;
  actions: string;
}

function descendingComparator<T>(a: T, b: T, orderBy: keyof T) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

type Order = 'asc' | 'desc';

function getComparator<Key extends keyof any>(
  order: Order,
  orderBy: Key,
): (
  a: { [key in Key]: number | string },
  b: { [key in Key]: number | string },
) => number {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

interface HeadCell {
  disablePadding: boolean;
  id: keyof Data;
  label: string;
  numeric: boolean;
}

const headCells: readonly HeadCell[] = [
  {
    id: 'name',
    numeric: false,
    disablePadding: true,
    label: 'Carrier',
  },
  {
    id: 'service',
    numeric: false,
    disablePadding: false,
    label: 'Service Level',
  },
  {
    id: 'transitDays',
    numeric: false,
    disablePadding: false,
    label: 'Est. Transit',
  },
  {
    id: 'total',
    numeric: true,
    disablePadding: false,
    label: 'Total',
  },
  {
    id: 'actions',
    numeric: true,
    disablePadding: false,
    label: 'Actions',
  },
];

interface EnhancedTableProps {
  numSelected: number;
  onRequestSort: (event: React.MouseEvent<unknown>, property: keyof Data) => void;
  // onSelectAllClick: (event: React.ChangeEvent<HTMLInputElement>) => void;
  order: Order;
  orderBy: string;
  rowCount: number;
}

function EnhancedTableHead(props: EnhancedTableProps) {
  const { numSelected, order, orderBy, onRequestSort } =
    props;
  const createSortHandler =
    (property: keyof Data) => (event: React.MouseEvent<unknown>) => {
      onRequestSort(event, property);
    };
  const classes = useStyles({})
    

  return (
    <TableHead>
      <TableRow>

        {headCells.map((headCell) => (
        <Fragment key={headCell.id}>
          <TableCell            
            align={headCell.label === 'Total' ? 'right' :  headCell.label === 'Actions' || headCell.label === 'Est. Transit' ? 'center': 'left'}
            sx={{width: headCell.label === 'Service Level' ? '50%' :  headCell.label === 'Actions' ? '144px': 'calc(16.6667% + 0px)', justifyContent: headCell.label === 'Est. Transit' ? 'center' : 'left'}}
            padding={headCell.disablePadding ? 'none' : 'normal'}
            sortDirection={orderBy === headCell.id ? order : false}
            className={headCell.label === 'Est. Transit' ? 'd-flex w-100' : undefined}
          >            
            {headCell.label === 'Est. Transit' ? <div style={{width: 24}}>&nbsp;</div> : null}
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : 'asc'}
              onClick={createSortHandler(headCell.id)}

            >
              {headCell.label}
              {orderBy === headCell.id ? (
                <Box component="span" sx={visuallyHidden}>
                  {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                </Box>
              ) : null}
            </TableSortLabel>
          </TableCell>
          </Fragment>
        ))}
      </TableRow>
    </TableHead>
  );
}

const SAVE_QUOTE = '/applet/v1/rate/save'

export const RatesTable = memo(({vendorsFiltered, vendorsProcessed, tableFor, linearProgress, rates, origin, destination, source, ratesStopped, setRatesStopped, loadQuotes, ratesLTL, values, selectedAcc, selectedUn}: RatesTableProps) => {
  const navigate = useNavigate();
  const classes = tableStyles()
  const dispatch = useDispatch()
  const [rateTypes, setRateTypes] = useState([])
  const [rateTypeSelected, setRateTypeSelected] = useState('ALL RATES')
  const [filteredRates, setFilteredRates] = useState([])
  const [openSaveModal, setOpenSaveModal] = useState(false)
  const [openQuoteBreakdownModal, setOpenQuoteBreakdownModal] = useState(false)
  const [quoteBreakdownModalData, setQuoteBreakdownModalData] = useState({})
  const [openEmailDocumentsModal, setOpenEmailDocumentsModal] = useState(false)
  const [selectedRow, setSelectedRow] = useState({} as any)
  const [searchTable, setSearchTable] = useState("")
  const user: UserModel = useSelector<RootState>(({auth}) => auth.user, shallowEqual) as UserModel
  const [quote, setQuote] = useState([{
    rateId: '',
    quoteId: null,
    quoteNumber: '',
    url: ''
  }])
  const [saving, setSaving] = useState(false)

  const [order, setOrder] = React.useState<Order>('asc');
  const [orderBy, setOrderBy] = React.useState<keyof Data>('total');
  const [selected, setSelected] = React.useState<readonly number[]>([]);

  const handleRequestSort = (
    event: React.MouseEvent<unknown>,
    property: keyof Data,
  ) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const visibleRows = 
  React.useMemo(
    () =>
      [...filteredRates]
        .sort(getComparator(order, orderBy)),
        // .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage),
    [order, orderBy, filteredRates],
  );  

  const carrierRender = (rowData) => {
    return (
      <>
        <Suspense fallback={'loading'}>
          <img alt="icon" src={rowData.iconUrl} style={{width: 70}}/>
          <p style={{fontWeight: 500, marginBottom: 3}}>{rowData.name}</p>
          {user.showSCACScore ? <Rating value={rowData.rating} precision={0.5} readOnly /> : null}
        </Suspense>
      </>
    )
  }

  const serviceLevelRender = (rowData) => {
    return (
      <>
        <p className="mb-3" style={{fontWeight: 500}}>{rowData?.serviceLevel}</p>
        {rowData.rateRemarks?.length && rowData.rateRemarks[0]
          ? <div className='d-flex'>
            <KTSVG path='/media/icons/bootstrap/exclamation-triangle-fill.svg' className='svg-icon svg-icon-6 text-danger me-1'/>
            <div>
              {rowData.rateRemarks.map(remark => {
                return <Fragment key={remark}><span  dangerouslySetInnerHTML={{ __html: remark }} /><br></br></Fragment>
              })}
            </div>
          </div>
          : null
        }
      </>
    )
  }

  const totalRender = (rowData) => {
    return (
      <button
        style={{
            backgroundColor: 'transparent',
            border: 'none',
            padding: 0,
            textDecoration: 'underline'
        }}
        onClick={() => {
          setQuoteBreakdownModalData(rowData)
          setOpenQuoteBreakdownModal(true)
        }}
      >
        {dollarUSLocale.format(rowData.total)}
      </button>
    )
  }

  const actionsButtons = (rowData) => {
    return (    
    <Box sx={{display: 'flex', width: '100px'}}>
        <Tooltip sx={{width: '35px'}} title={!quote.filter(a => a.rateId === rowData.id)?.length ? 'Save Rate' : 'Download PDF'}>
        <span style={{width: '35px'}}>
          <Button 
            sx={{minWidth: '30px'}}
            onClick={() => {              
              setSelectedRow(rowData)
              if(!quote.filter(a => a.rateId === rowData.id)?.length){
                setOpenSaveModal(true)
                setSelectedRow(rowData)
              }else{
                saveAs(quote.filter(a => a.rateId === selectedRow.id)[0]?.url)
              }
            }}
          >
            {!quote.filter(a => a.rateId === rowData.id)?.length ? 
            <SaveIcon style={{color: '#0095E8'}}/> : 
            <KTSVG className="svg-icon svg-icon-3 d-flex align-items-center justify-content-center" style={{color: '#0095E8'}} path='/media/icons/bootstrap/file-earmark-pdf-fill.svg'/>
            }
          </Button>
        </span>
        </Tooltip>
      {quote.filter(a => a.rateId === rowData.id)?.length > 0 && 
        <Tooltip sx={{width: '35px'}} title={quote.filter(a => a.rateId === rowData.id)?.length ? 'Email Documents' : ''}>
            <span style={{width: '35px'}}>
              <Button
                sx={{minWidth: '30px'}}
                onClick={() => {
                  setOpenEmailDocumentsModal(true)
                }}
              >                
                <EmailIcon style={{color: '#F1416C', width: 21, height: 21}}/>                
              </Button>
            </span>
        </Tooltip>
      }
      {user.allowBooking &&
        <Tooltip sx={{width: '35px'}} title={'Book Rate'}>
            <span style={{width: '35px'}}>
              <Button
                sx={{minWidth: '30px'}}
                onClick={() => {
                  setSelectedRow(rowData)
                  bookRate(rowData)
                }}
              >
                {(saving && rowData.id === selectedRow.id) ? <span className='spinner-border spinner-border-sm align-middle' style={{color: '#47BE7D'}}></span> : <BookIcon style={{color: '#47BE7D'}}/>}
              </Button>
            </span>
        </Tooltip>
      }
    </Box>      
    )
  }

  const serviceLevelCustomSort = (a, b) => (
    a.serviceLevel.trim()?.localeCompare(b.serviceLevel.trim())
  )

  const transitCustomSort = (a, b) => (
    (a.transitDays === "-" ? 99 : a.transitDays) - (b.transitDays === '-' ? 99 : b.transitDays)
  )

  const [columns] = useState([
    { title: 'Carrier', field: 'name', render: carrierRender },
    { title: 'Service Level', field: 'serviceLevel', width: "50%", render: serviceLevelRender, customSort: serviceLevelCustomSort},
    { title: 'Est. Transit', field: 'transitDays', customSort: transitCustomSort },
    { title: 'Total', field: 'total', defaultSort: 'asc', type: 'currency',  render: totalRender}
  ] as Column<Array<RowTableObject>>[])

  // const columns = useMemo(
  //   () => [
  //     { title: 'Carrier', field: 'name', render: carrierRender },
  //     { title: 'Service Level', field: 'serviceLevel', width: "50%", render: serviceLevelRender, customSort: serviceLevelCustomSort},
  //     { title: 'Est. Transit', field: 'transitDays', customSort: transitCustomSort },
  //     { title: 'Total', field: 'total', defaultSort: 'asc', type: 'currency',  render: totalRender}
  //   ] as Column<Array<RowTableObject>>, [],
  // );

  useEffect(() => {
    rates.forEach(rate => {
      if(!(rateTypes.filter(function(e) { return e.value === rate?.rateType; }).length > 0)){
        let stringLowerCase = rate.rateType?.toLowerCase()
        let stringFirstCharUpperCase = stringLowerCase?.charAt(0)?.toUpperCase() + stringLowerCase?.slice(1)

        setRateTypes([...rateTypes, {value: rate?.rateType, name: rate?.rateType?.length > 3 ? stringFirstCharUpperCase : rate?.rateType}])
      }
    })

    if(!(rates.length >= 1)){
      setRateTypeSelected('ALL RATES')
      setSearchTable('')
      setRateTypes([])
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [rates])

  useEffect(() => {
    if(loadQuotes === true){
      ratesLTL?.forEach(rate => {
        if(!(rateTypes.filter(function(e) { return e.value === rate.rateType; }).length > 0)){
          let stringLowerCase = rate.rateType?.toLowerCase()
          let stringFirstCharUpperCase = stringLowerCase.charAt(0).toUpperCase() + stringLowerCase.slice(1)
  
          setRateTypes([...rateTypes, {value: rate.rateType, name: rate.rateType.length > 3 ? stringFirstCharUpperCase : rate.rateType}])
        }
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loadQuotes])

  useEffect(() => {
    let newRatesArray
    if(rateTypeSelected === 'ALL RATES'){
      newRatesArray = rates.filter(rate => {
        return rate.name?.toLowerCase().trim().includes(searchTable?.toLowerCase().trim()) || rate.serviceLevel?.toLowerCase().trim().includes(searchTable?.toLowerCase().trim())
      })
    }else{
      newRatesArray = rates.filter(rate => {
        return rate.rateType === rateTypeSelected
      })
      newRatesArray = newRatesArray.filter(rate => {
        return rate.name?.toLowerCase().trim().includes(searchTable?.toLowerCase().trim()) || rate.serviceLevel?.toLowerCase().trim().includes(searchTable?.toLowerCase().trim())
      })
    }

    if(rateTypeSelected === 'ALL RATES' && searchTable === ''){
      setFilteredRates([])
    }

    setFilteredRates(newRatesArray)
    
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [rateTypeSelected, searchTable, rates])

  const handleSearch = (e) => {
    setSearchTable(e.target.value)
  }

  const cancelCalls = () => {
    source.cancel('Operation canceled by the user.');
  }

  const bookRate = (rowData) => {
    if(!quote.filter(a => a.rateId === rowData.id)?.length){
      setSaving(true)
      axios.post(SAVE_QUOTE, {
        rateId: rowData?.id,
        originShippingLocationId: origin?.id ? origin?.id : 0,
        destinationShippingLocationId: destination?.id ? destination?.id : 0,
        laneDistance: values.laneDistance
      }).then(result => {
        setQuote([...quote, {
          rateId: rowData?.id,
          quoteId: result.data.data.results.quoteId,
          quoteNumber: result.data.data.results.quoteNumber,
          url: result.data.data.results.url
        }])
        setSaving(false)

        dispatch({
          type: actionTypes.SetQuoteValues,
          payload: {
            ...values,
            mode: tableFor === 'Volume/TL' ? 'Volume' : tableFor,
            freightInfoReclassed: rowData?.freightInfoReclassed,
            carrierInformation: rowData,
            quoteNumber: result.data.data.results?.quoteNumber,
            url: result.data.data.results?.url,
            accessorials: selectedAcc || values?.accessorials,
            selectedUn: selectedUn,
            newAccessorials: rowData.accessorialsList,
            commodityInsurance: values?.commodityInsurance || '',
            insuranceAmount: values?.insuranceAmount || null,
            insuranceFreight: values?.insuranceFreight || false,
            insuranceAddOn: values?.insuranceAddOn || false ,
          }
        })
        cancelCalls()
        setRatesStopped(true)        
        navigate('/book/new-booking')
      }).catch(error => {
        setSaving(false)
        checkErrorAPICall(error, dispatch, 'Save Quote')
      })
    }else{
      dispatch({
        type: actionTypes.SetQuoteValues,
        payload: {
          ...values,
          mode: tableFor === 'Volume/TL' ? 'Volume' : tableFor,
          freightInfoReclassed: rowData.freightInfoReclassed,
          carrierInformation: rowData,
          quoteNumber: quote.filter(q => q?.rateId === rowData?.id)[0]?.quoteNumber,
          selectedUn: selectedUn,
          newAccessorials: rowData.accessorialsList
        }
      })
      navigate('/book/new-booking')
    }
  }  

  return (
    <>
      <Toolbar
        tableFor={tableFor}
        searchTable={searchTable}
        handleSearch={handleSearch}
        rateTypeSelected={rateTypeSelected}
        setRateTypeSelected={setRateTypeSelected}
        rateTypes={rateTypes}
        columns={columns}
        dataColumns={filteredRates.length >= 1 || searchTable.length >= 1 ? filteredRates : rates}
        cancelCalls={cancelCalls}
        linearProgress={linearProgress}
        ratesStopped={ratesStopped}
        setRatesStopped={setRatesStopped}
      />

      <div className='d-flex justify-content-center mt-5'>
        <b>{linearProgress >= 100 || ratesStopped ? 'Rating finished' : 'Loading carriers...'}</b>
      </div>
      <div className='d-flex justify-content-center'>
        {`${linearProgress > 0 ? vendorsProcessed : '0'} of ${vendorsFiltered?.length} processed - ${rates?.length} ${rates?.length === 1 ? 'rate' : 'rates'} found`}
      </div>

      <div className="mt-3">
        <LinearProgress
          variant="determinate"
          value={linearProgress}
          style={{backgroundColor: '#94d8ff'}}
          className={classes.linearProgress}
        />
      </div>

      <div className="mt-5">
        {/* <MaterialTable
          style={{boxShadow: 'none', fontFamily: 'Poppins !important'}}
          columns={columns}
          data={filteredRates?.length >= 1 || searchTable?.length >= 1 ? filteredRates : rates}
          title=""
          actions={[
            (rowData: any) => ({
              icon: () => !quote.filter(a => a.rateId === rowData.id)?.length ? <SaveIcon style={{color: '#0095E8'}}/> : <KTSVG className="svg-icon svg-icon-3 d-flex align-items-center justify-content-center" style={{color: '#0095E8'}} path='/media/icons/bootstrap/file-earmark-pdf-fill.svg'/>,
              tooltip: !quote.filter(a => a.rateId === rowData.id)?.length ? 'Save Rate' : 'Download PDF',
              onClick: (event, rowData: any) => {
                setSelectedRow(rowData)
                if(!quote.filter(a => a.rateId === rowData.id)?.length){
                  setOpenSaveModal(true)
                  setSelectedRow(rowData)
                }else{
                  saveAs(quote.filter(a => a.rateId === selectedRow.id)[0]?.url)
                }
              }
            }),
            (rowData: any) => (quote.filter(a => a.rateId === rowData.id)?.length && {
              icon: () => quote.filter(a => a.rateId === rowData.id)?.length && <EmailIcon style={{color: '#F1416C', width: 21, height: 21}}/>,
              tooltip: quote.filter(a => a.rateId === rowData.id)?.length ? 'Email Documents' : '',
              onClick: (event, rowData: any) => {
                setOpenEmailDocumentsModal(true)
              }
            }),
            (rowData: any) => ( user.allowBooking ? {
              icon: () => (saving && rowData.id === selectedRow.id) ? <span className='spinner-border spinner-border-sm align-middle' style={{color: '#47BE7D'}}></span> : <BookIcon style={{color: '#47BE7D'}}/>,
              tooltip: 'Book Rate',
              hidden: user?.lockedBOL,
              onClick: (event, rowData: any) => {
                setSelectedRow(rowData)
                bookRate(rowData)
              }
            } : null ),
          ]}
          options={{
            thirdSortClick: false,
            actionsColumnIndex: -1,
            toolbar: false,
            paging: false,
            filtering: false,
            searchFieldAlignment: 'left',
            draggable: false,
            rowStyle: (data, idx) => idx%2 !== 0 ? {
              backgroundColor: '#f4f4f4',
            } : {
              backgroundColor: '#ffff',
            },
          }}
          components={{
            Container: (props) => <Paper className={classes.table} {...props}/>,
          }}
        /> */}

        <Box sx={{ width: '100%' }}>
          <Paper sx={{ width: '100%', mb: 2 }} className={classes.table}>        
            <TableContainer>
              <Table
                sx={{ minWidth: 750}}
                aria-labelledby="tableTitle"
                size={'medium'}
              >
                <EnhancedTableHead
                  numSelected={selected.length}
                  order={order}
                  orderBy={orderBy}
                  // onSelectAllClick={handleSelectAllClick}
                  onRequestSort={handleRequestSort}
                  rowCount={visibleRows?.length}
                />
                <TableBody>            
                  {visibleRows?.map((row, index) => {
                    const isItemSelected = selected.includes(row.id);
                    const labelId = `enhanced-table-${index}`;

                    return (
                      <TableRow
                        // hover
                        // onClick={(event) => handleClick(event, row.id)}
                        role="checkbox"
                        aria-checked={isItemSelected}
                        tabIndex={-1}
                        key={row.id}
                        selected={isItemSelected}
                        sx={{ backgroundColor: index %2 !== 0 ? '#f4f4f4':'#ffff' }}
                      >
                        
                        <TableCell
                          component="th"
                          id={labelId}
                          scope="row"
                          padding="none"
                          sx={{width: 'calc(16.6667% + 0px)'}}
                        >
                          {carrierRender(row)}
                        </TableCell>
                        <TableCell align="left" style={{width: '50%'}}>{serviceLevelRender(row)}</TableCell>
                        <TableCell align="center" style={{width: 'calc(16.6667% + 0px)'}}>{row.transitDays}</TableCell>
                        <TableCell align="right" style={{width: 'calc(16.6667% + 0px)'}}>{totalRender(row)}</TableCell>
                        <TableCell align="right" style={{width: '144px'}}>{actionsButtons(row)}</TableCell>
                      </TableRow>
                    );
                  })}

                  {!rates.length && (
                    <TableRow>                
                      <TableCell align="center" colSpan={11}>
                          <Box sx={{ paddingTop: '20px !important', paddingBottom: '20px !important' }}>No records to display</Box>
                      </TableCell>                
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          
          </Paper>      
        </Box>
      </div>
      <SaveModal
        open={openSaveModal}
        setOpen={setOpenSaveModal}
        selectedRow={selectedRow}
        origin={origin}
        destination={destination}
        quote={quote}
        setQuote={setQuote}
        bookRate={bookRate}
        values={values}
      />
      <EmailDocuments
        open={openEmailDocumentsModal}
        setOpen={setOpenEmailDocumentsModal}
        documents={[{
            name: 'Customer Quote',
            url: quote.filter(a => a.rateId === selectedRow.id)[0]?.url,
            quoteNumber: quote.filter(a => a.rateId === selectedRow.id)[0]?.quoteNumber
        }]}
      />
      <QuoteBreakdownModal
        open={openQuoteBreakdownModal}
        setOpen={setOpenQuoteBreakdownModal}
        data={quoteBreakdownModalData}
      />
    </>
  )
})
